import { useSearchParams } from "next/navigation";
import { parse } from "qs";

import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import useSortQueryParam from "@/hooks/useSortQueryParam";
import pageFromQuery from "@/utils/pageFromQuery";

import {
  appliedFilterSections,
  extractFilterValues,
} from "@/components/UnifiedShop/utils/filterUtils";

const ALLOWED_CATEGORIES = [
  "Beverages",
  "Cartridges",
  "Concentrates",
  "Flower",
  "Gummies",
  "Pet Tinctures",
  "PreRolls",
  "Seeds",
  "Vape pens",
];

export const useShopItemAd = () => {
  const countryCode = useDomainCountryCode();
  const { appliedSort } = useSortQueryParam();
  const searchParams = useSearchParams();
  const parsedQs = parse(searchParams?.toString() || "");
  const { selectedCategories, selectedFulfillments } =
    extractFilterValues(parsedQs);
  const currentPage = pageFromQuery(
    parsedQs.page as string | string[] | undefined,
  );

  const showShopItemAd = () => {
    return (
      // don't show if filters (other than category) are selected
      !appliedFilterSections(parsedQs).some((item) => item !== "category") &&
      // don't show if more than one category filter is selected
      (selectedCategories?.length || 0) <= 1 &&
      // only show if selected category is in allow list
      (selectedCategories?.length !== 1 ||
        ALLOWED_CATEGORIES.includes(selectedCategories[0])) &&
      // don't show if fulfillments are selected
      (selectedFulfillments?.length || 0) === 0 &&
      // only show on page 1
      currentPage === 1 &&
      // only show if non-default sort is applied
      appliedSort === undefined &&
      // only show if on US
      countryCode === "US"
    );
  };

  const targeting = () => {
    if (showShopItemAd()) {
      if (selectedCategories?.length === 1) {
        return { category: selectedCategories[0] };
      } else {
        return { category: "home" };
      }
    } else {
      return {};
    }
  };

  return {
    showShopItemAd,
    targeting,
  };
};
